const normalizeStationId = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();

const parseChartHistory = (chartHistory) => {
  if (!chartHistory) return {};
  if (typeof chartHistory === "object") return chartHistory;
  if (typeof chartHistory !== "string") return {};

  try {
    return JSON.parse(chartHistory);
  } catch {
    return {};
  }
};

export const isCancelledPatient = (patient = {}) =>
  String(patient.patient_type || "").toLowerCase() === "cancelled" ||
  String(patient.status || "").toLowerCase() === "cancelled";

export const isScheduledElsewherePatient = (patient = {}) =>
  String(patient.patient_type || "").toLowerCase() === "scheduled_elsewhere";

export const getCrossSiteCareStatus = (patient = {}) => {
  if (!isScheduledElsewherePatient(patient)) {
    return null;
  }

  const chartHistory = parseChartHistory(patient.chart_history);
  const expectedSta3n = normalizeStationId(chartHistory.sta3n);

  return {
    sta3n: expectedSta3n,
    facilityName:
      patient.care_site?.facilityName ||
      (expectedSta3n ? `VA Station ${expectedSta3n}` : "Another VA facility"),
    displayName:
      patient.care_site?.displayName ||
      (expectedSta3n ? `Station ${expectedSta3n}` : "Scheduled facility"),
  };
};
